import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import { FAILURE_PRODUCT_GROUPS, REQUEST_PRODUCT_GROUPS, SUCCESS_PRODUCT_GROUPS } from './actions';

export function productGroupReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_PRODUCT_GROUPS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_PRODUCT_GROUPS:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_PRODUCT_GROUPS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
